import { Avatar, Button, Card, CardBody, CardHeader } from '@heroui/react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useGetLastTrackerQuery } from '@/patient-app-common/api/trackerApi';

interface DailyResultProps {
  mainTrackerId: number;
}

export function DailyResult({ mainTrackerId }: DailyResultProps) {
  const { t } = useTranslation('home');
  const navigate = useNavigate();

  const { data: mainTrackerEntry } = useGetLastTrackerQuery(mainTrackerId);

  if (!mainTrackerEntry?.result) return null;
  const { result } = mainTrackerEntry;

  const date = dayjs(mainTrackerEntry?.createdAt).format('LL');
  const icon = `/icons/${result.apptext.recIconImage}`;

  const openResult = () => {
    navigate(`/recommendation/${mainTrackerEntry.procedureId}`, {
      state: {
        patientEntry: mainTrackerEntry,
      },
    });
  };

  return (
    <Card>
      <div className="font-light text-sm p-2">
        <p>{t('common.text.completed_date', { date })}</p>
      </div>
      <CardHeader className="gap-4">
        <Avatar
          size="md"
          src={icon}
          style={{
            backgroundColor: result.apptext.recRecommendationBackgroundColor,
          }}
        />
        <h3 className="font-semibold text-lg">{result.apptext.recLabelText}</h3>
      </CardHeader>
      <CardBody>
        <Button color="primary" onPress={openResult}>
          {t('dailyresult.button.open')}
        </Button>
      </CardBody>
    </Card>
  );
}
